import { UzBadge } from '@utazzo/ui';
import React from 'react';

import { statusLabel, statusTone } from '../booking-format';

/** One badge for every booking status, so the list, the detail and the bell agree. */
export const BookingStatusBadge = ({
  status,
  className,
}: {
  status: string;
  className?: string;
}): React.JSX.Element => (
  <UzBadge tone={statusTone(status)} dot={status === 'ON_HOLD'} pill className={className}>
    {statusLabel(status)}
  </UzBadge>
);
